export const bonuses = [
  {
    label: 'Bono 1',
    title: 'Presentaciones de salud listas',
    body: 'Presentaciones visuales para acompañar tus principales charlas sin empezar cada diapositiva desde cero.',
    highlight: 'Abrí → personalizá → presentá',
  },
  {
    label: 'Bono 2',
    title: 'Folletos para pacientes y comunidad',
    body: 'Material educativo listo para imprimir o compartir después de una charla, consulta o actividad.',
    highlight: 'Explicá → compartí → reforzá',
  },
  {
    label: 'Bono 3',
    title: '100 actividades educativas para salud',
    body: 'Verdadero o falso, mitos y realidades, casos, dinámicas, preguntas y actividades participativas.',
    highlight: 'Preguntá → hacé participar → reforzá',
  },
  {
    label: 'Bono 4',
    title: 'Calendario anual de educación para la salud',
    body: 'Ideas de temas, campañas y actividades para organizar tu año sin preguntarte cada mes qué preparar.',
    highlight: 'Planificá → organizá → educá',
  },
  {
    label: 'Bono 5',
    title: 'Kit sala de espera',
    body: 'Microcharlas de 5 a 10 minutos pensadas para hospitales, CAPS y consultorios.',
    highlight: 'Elegí el tema → explicá → cerrá',
  },
];
